import React, { useState } from 'react';
import axios from 'axios';
import { MessageSquare, X, Star, Send, CheckCircle } from 'react-feather';

const api = process.env.REACT_APP_API_URL;

export default function FeedbackWidget() {
  const [open,    setOpen]    = useState(false);
  const [rating,  setRating]  = useState(0);
  const [hovered, setHovered] = useState(0);
  const [text,    setText]    = useState('');
  const [done,    setDone]    = useState(false);
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (rating === 0 || sending) return;
    setSending(true);
    const entry = { rating, text, url: window.location.pathname };
    try {
      await axios.post(`${api}feedback/`, entry);
    } catch (err) {
      // Network/throttle failure: keep a local backup so nothing is lost.
      const history = JSON.parse(localStorage.getItem('feedback') || '[]');
      history.push({ ...entry, ts: new Date().toISOString() });
      localStorage.setItem('feedback', JSON.stringify(history));
    } finally {
      setSending(false);
      setDone(true);
      setTimeout(() => { setOpen(false); setDone(false); setRating(0); setText(''); }, 2000);
    }
  };

  return (
    <>
      {/* Floating trigger button */}
      <button
        onClick={() => setOpen(v => !v)}
        className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-violet-600 text-white shadow-lg flex items-center justify-center hover:bg-violet-500 transition-all"
        title="Give feedback"
      >
        {open ? <X className="w-5 h-5" /> : <MessageSquare className="w-5 h-5" />}
      </button>

      {/* Panel */}
      {open && (
        <div className="fixed bottom-20 right-6 z-50 w-80 bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          {/* Header */}
          <div className="bg-violet-600 px-4 py-3">
            <h3 className="text-white font-semibold text-sm">How's your experience?</h3>
            <p className="text-violet-200 text-xs mt-0.5">Your feedback helps us improve</p>
          </div>

          {done ? (
            <div className="flex flex-col items-center gap-2 py-8 text-green-600">
              <CheckCircle className="w-10 h-10" />
              <p className="font-semibold">Thank you!</p>
            </div>
          ) : (
            <div className="p-4 space-y-4">
              {/* Star rating */}
              <div>
                <p className="text-xs text-gray-500 mb-2">Overall satisfaction</p>
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map(n => (
                    <button
                      key={n}
                      onMouseEnter={() => setHovered(n)}
                      onMouseLeave={() => setHovered(0)}
                      onClick={() => setRating(n)}
                      className="transition"
                    >
                      <Star
                        className="w-7 h-7 transition-colors"
                        fill={(hovered || rating) >= n ? '#b08d57' : 'none'}
                        stroke={(hovered || rating) >= n ? '#b08d57' : '#cabfa9'}
                      />
                    </button>
                  ))}
                </div>
              </div>

              {/* Text field */}
              <textarea
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="What worked well or could be better? (optional)"
                rows={3}
                className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-violet-300 bg-gray-50"
              />

              <button
                onClick={submit}
                disabled={rating === 0 || sending}
                className="w-full py-2.5 rounded-xl bg-violet-600 text-white text-sm font-semibold hover:bg-violet-500 disabled:opacity-40 transition flex items-center justify-center gap-2"
              >
                <Send className="w-4 h-4" /> {sending ? 'Sending…' : 'Submit Feedback'}
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
